const MOBILE_MEDIA_QUERY = '(max-width: 768px)';
const EXPAND_THRESHOLD_PX = 1;

const mobileMq = window.matchMedia(MOBILE_MEDIA_QUERY);

/**
 * @param {Element} element
 * @returns {string}
 */
function getNormalizedText(element) {
  return (element.textContent || '').replace(/\u00a0/g, ' ').trim();
}

/**
 * @param {Element} description
 * @param {HTMLButtonElement} button
 */
function resetBlock(description, button) {
  description.classList.remove('is-expanded');
  button.hidden = true;
  button.style.display = 'none';
  button.setAttribute('aria-expanded', 'false');
  button.textContent = 'Read more';
}

/**
 * @param {Element} block
 */
function updateBlock(block) {
  const description = block.querySelector('.plp-intro-description');
  const button = /** @type {HTMLButtonElement | null} */ (block.querySelector('.plp-intro-read-more'));

  if (!description || !button) return;

  if (!mobileMq.matches || !getNormalizedText(description)) {
    resetBlock(description, button);
    return;
  }

  const wasExpanded = description.classList.contains('is-expanded');

  if (wasExpanded) {
    description.classList.remove('is-expanded');
  }

  const canExpand = description.scrollHeight - description.clientHeight > EXPAND_THRESHOLD_PX;

  if (wasExpanded && canExpand) {
    description.classList.add('is-expanded');
  }

  button.hidden = !canExpand;
  button.style.display = canExpand ? '' : 'none';

  if (!canExpand) {
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'Read more';
  }
}

function updateAllBlocks() {
  document.querySelectorAll('.plp-intro-block').forEach(updateBlock);
}

/** @type {number | null} */
let rafId = null;

function scheduleUpdate() {
  if (rafId !== null) return;

  rafId = window.requestAnimationFrame(() => {
    rafId = null;
    updateAllBlocks();
  });
}

function initPlpIntroReadMore() {
  scheduleUpdate();
  window.setTimeout(scheduleUpdate, 100);

  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('load', scheduleUpdate);

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPlpIntroReadMore, { once: true });
} else {
  initPlpIntroReadMore();
}
